import React from 'react';

const LocalBusinessSchema = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://house-cleaning-quote-1.preview.emergentagent.com",
    "name": "Texas House Cleaning",
    "description": "Professional residential cleaning services throughout Texas. We offer standard cleaning, deep cleaning, and move-out cleaning with eco-friendly products.",
    "url": "https://house-cleaning-quote-1.preview.emergentagent.com",
    "telephone": "+13462031728",
    "email": "clean.texashouse@gmail.com",
    "priceRange": "$$",
    "image": "https://customer-assets.emergentagent.com/job_house-cleaning-quote-1/artifacts/oimdgj31_texas_logo.png",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "TX",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "31.9686",
      "longitude": "-99.9018"
    },
    "areaServed": {
      "@type": "State",
      "name": "Texas"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "08:00",
        "closes": "18:00"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Cleaning Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Standard Cleaning",
            "description": "Regular maintenance cleaning to keep your home fresh and tidy. Perfect for weekly or bi-weekly schedules."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Deep Cleaning",
            "description": "Comprehensive top-to-bottom cleaning that tackles every corner of your home. Ideal for seasonal refresh."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Move-Out Cleaning",
            "description": "Thorough cleaning for moving in or out. Get your deposit back or welcome new residents to a spotless home."
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": "150"
    },
    "sameAs": []
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

export default LocalBusinessSchema;
